// extracted by mini-css-extract-plugin
export var circle = "_2c-2";
export var icon = "_2c-a";
export var iconHighlight = "_2c-0";
export var lg = "_2c-8";
export var md = "_2c-7";
export var outline = "_2c-4";
export var sm = "_2c-6";
export var square = "_2c-1";
export var xl = "_2c-9";
export var xs = "_2c-5";
export var xxs = "_2c-3";